export function cropRegion(width:number,height:number,ratio:number,zoom:number,x:number,y:number){
 const baseW=Math.min(width,height*ratio),baseH=baseW/ratio,w=baseW/zoom,h=baseH/zoom;
 return {x:Math.max(0,Math.min(width-w,(width-w)*x)),y:Math.max(0,Math.min(height-h,(height-h)*y)),width:w,height:h};
}
